export default {
  errorDefault: 'Si è verificato un errore',
  unknown: 'Sconosciuto',
};
